import { Stack, Typography, Box } from "@mui/material";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
} from "recharts";

function CustomBarChart({
  title,
  chartData,
  dataKey_xaxis,
  dataKey_yaxis1,
  color1,
  borderRight = 0,
  barWidth = 40, // You can customize this!
  chartHeight = 220,
  margin = { top: 12, right: 10, left: 10, bottom: 20 },
  xAxisLabelAngle = 0,
  sorted = false
}) {
  const borderRadius = 0;

  // Calculate chart width based on data length
  const numBars = chartData.length;
  const chartWidth = Math.max(
    350,
    barWidth * numBars + margin.left + margin.right
  ); // minimum 350px

  // const sortedData = [...chartData].sort(
  //   (a, b) => b[dataKey_yaxis1] - a[dataKey_yaxis1]
  // );
  console.log("chartData", chartData);
  const sortedData = sorted ? [...chartData].sort((a, b) => b[dataKey_yaxis1] - a[dataKey_yaxis1]) : chartData;
  return (
    <Stack
      sx={{
        width: "100%",
        borderRadius: borderRadius,
        border: 0,
        borderColor: "lightgray",
        borderRight: borderRight,
      }}
    >
      <Typography
        align="center"
        sx={{
          py: 0.5,
          fontSize: 14,
          fontWeight: "bold",
          color: "secondary.main",
        }}
      >
        {title}
      </Typography>
      {/* Horizontal scroll wrapper */}
      <Box sx={{ width: "100%", overflowX: "auto",  overflowY: "hidden"  }}>
        <Box sx={{ minWidth: chartWidth }}>
          {/* ResponsiveContainer will fill the minWidth, so chart is always readable */}
          <BarChart
            width={chartWidth}
            height={chartHeight}
            data={sortedData}
            margin={margin}
            barGap={0}
            barSize={barWidth}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey={dataKey_xaxis}
              tickLine={false}
              tick={{
                fontSize: 12,
                fontWeight: "bold",
                angle: xAxisLabelAngle,
                textAnchor: xAxisLabelAngle === 0 ? "middle" : "end",
              }}
              interval={0}
            />
            <YAxis tick={{ fontSize: 14 }} />
            <Tooltip />
            <Bar dataKey={dataKey_yaxis1} fill={color1}>
              <LabelList
                dataKey={dataKey_yaxis1}
                position="top"
                style={{ fontSize: 14 }}
              />
            </Bar>
          </BarChart>
        </Box>
      </Box>
    </Stack>
  );
}

export default CustomBarChart;
